'use strict';

/*eslint-disable no-unused-vars */
export default function appRun(analytics, $rootScope, $state, $stateParams, $window, config, session, tracking, userModel, marketingId, lazysizes, stopRemarketing, realtime, remarketing, fbCampaignHandler, bodyElement, messenger, development, locationConfirmationService, notification, sounds, systemAlerts, listingPrice, /*appBanner,*/ appBecomeGuideBanner, meta, $location, $cookies) {
/*eslint-enable no-unused-vars */
  'ngInject';

  // $rootScope.$on('$stateChangeError', console.log.bind(console));

  development.deleteAdminCookieInDevelopment();

  var sessionData;
  // const userIsBlockedEventName = 'Blocked';

  meta.init();
  session.init();
  tracking.init();

  sessionData = session.get();

  realtime.init();

  userModel.initItem(sessionData && sessionData.userId);

  $rootScope.$on('userModel:initialized', () => {

    // if(userModel.item.isSuspended) {
    //   analytics.trackPage($state.current.url, userIsBlockedEventName);
    // }

    if (userModel.item.isSuspended && window.location.pathname !== '/account-is-suspended') {
      window.location.replace('/account-is-suspended');
    }

    sounds.init();
    notification.init();
    var reqRef = $stateParams.reqRef;
    if (!reqRef) {
      locationConfirmationService.checkShow().then(() => {
        //messenger.showModal();
        //recurringMessenger.recur();

        try {
          locationConfirmationService.showModal();
        } catch(e) {
          // $window.Raven.captureException(e);
        }
      });
    }
  });

  if($cookies.get('disable_cookies_line') === 'disabled'){
    $rootScope.isCookiesLineEnabled = false;
  }else{
    $rootScope.isCookiesLineEnabled = true;
  }

  if($cookies.get('disable_fb_pixel') === 'disabled'){
    $rootScope.isFbPixelEnabled = false;
    $rootScope.facebookPixel    = false;
  }else{
    $rootScope.isFbPixelEnabled = true;
    $rootScope.facebookPixel    = true;
  }

  if($cookies.get('disable_google_analytics') === 'disabled'){
    $rootScope.analytics                = false;
  }else{
    $rootScope.analytics                = true;
  }

  if($cookies.get('disable_google_adwords') === 'disabled'){
    $rootScope.isAdWordsEnabled = false;
    $rootScope.adWords          = false;
  }else{
    $rootScope.isAdWordsEnabled = true;
    $rootScope.adWords          = true;
  }
  if($cookies.get('disable_taboola') === 'disabled') {
    $rootScope.taboola = false;
  } else {
    $rootScope.taboola = true;
  }

  if (config.env !== 'local' && $rootScope.analytics) {
    $rootScope.$on('$stateChangeSuccess', () => {
      let state = $state.current;
      analytics.pageview($location.url(), state.analyticsName);
    });
  }

  marketingId.init();
  lazysizes.init();
  stopRemarketing.init();
  remarketing.init();
  fbCampaignHandler();
  //appBanner.init();
  appBecomeGuideBanner.init();

  // // Facebook tracking code after 7seconds
  // function sendFacebookTrackingDataAfter7Seconds() {
  //   const cookieName = 'fb7sec';
  //   if (!localStorage.getItem(cookieName)) {
  //     localStorage.setItem(cookieName, 'y');
  //     setTimeout(() => {
  //       if (typeof fbq !== 'undefined') {
  //         fbq('track', 'AddToCart');
  //       }
  //     }, 7000);
  //   }
  // }
  //
  // sendFacebookTrackingDataAfter7Seconds();

}



// WEBPACK FOOTER //
// ./app/src/app.run.js